import { Controller } from "stimulus"

// #1921 ronde 12: Instellingen > Factuur.
//
// De kleurkiezer en het HEX-veld werken elkaar bij; een leeg HEX-veld
// betekent "uit de huisstijl". Na een wijziging stuurt het formulier zichzelf
// (na een korte pauze) naar de voorbeeld-URL, met het iframe als doel: de
// voorbeeldfactuur ververst dan zonder dat er iets is opgeslagen.
export default class extends Controller {
  static targets = ["kiezer", "hex", "vernieuwen"]

  connect() {
    this.timer = null
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  kiesKleur(event) {
    const hex = this.hexVoor(event.target.dataset.veld)
    if (hex) hex.value = event.target.value.toUpperCase()
    this.wijzig()
  }

  typHex(event) {
    const waarde = this.normaliseer(event.target.value)
    const kiezer = this.kiezerVoor(event.target.dataset.veld)
    if (kiezer) kiezer.value = (waarde || event.target.dataset.standaard || "#000000").toLowerCase()
    event.target.setAttribute("aria-invalid", event.target.value.trim() !== "" && !waarde ? "true" : "false")
    this.wijzig()
  }

  leegMaken(event) {
    event.preventDefault()
    const veld = event.currentTarget.dataset.veld
    const hex = this.hexVoor(veld)
    if (!hex) return
    hex.value = ""
    hex.setAttribute("aria-invalid", "false")
    const kiezer = this.kiezerVoor(veld)
    if (kiezer) kiezer.value = (hex.dataset.standaard || "#000000").toLowerCase()
    this.wijzig()
  }

  wijzig() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.vernieuw(), 700)
  }

  vernieuw(event) {
    if (event) event.preventDefault()
    clearTimeout(this.timer)
    if (!this.hasVernieuwenTarget) return
    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit(this.vernieuwenTarget)
    } else {
      this.vernieuwenTarget.click()
    }
  }

  hexVoor(veld) {
    return this.hexTargets.find((el) => el.dataset.veld === veld)
  }

  kiezerVoor(veld) {
    return this.kiezerTargets.find((el) => el.dataset.veld === veld)
  }

  normaliseer(waarde) {
    let tekst = (waarde || "").trim().replace(/^#/, "")
    if (!/^([0-9a-f]{3}|[0-9a-f]{6})$/i.test(tekst)) return null
    if (tekst.length === 3) tekst = tekst.split("").map((c) => c + c).join("")
    return `#${tekst.toUpperCase()}`
  }
}
